import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  error: null,
  status: 'idle',
};

export const createReport = createAsyncThunk(
  '/create-report',
  async (values, rejectWithValue) => {
    const reportData = { ...values };
    // let sixParams = false;

    if (
      reportData.iron === '' &&
      reportData.calcium === '' &&
      reportData.boron === '' &&
      reportData.sulphur === '' &&
      reportData.magnesium === '' &&
      reportData.zinc === ''
    ) {
      // sixParams = true;
      const { iron, calcium, boron, sulphur, magnesium, zinc, ...sixParam } =
        reportData;
      try {
        const { data } = await axiosInstance.post('/super-admin/create-report', {
          ...sixParam,
        });
        return data;
      } catch (err) {
        return rejectWithValue(err.response.data.msg);
      }
    } else {
      try {
        const { data } = await axiosInstance.post('/super-admin/create-report', {
          ...values,
        });
        return data;
      } catch (err) {
        console.log("Error while createing report: ", err)
        return rejectWithValue(err.response.data.msg);
      }
    }

    // console.log('Six params: ', sixParams);
  }
);

export const createWaterReport = createAsyncThunk(
  '/create-water-report',
  async (values, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        '/super-admin/create-water-report',
        values
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Error');
    }
  }
);

export const createReportSlice = createSlice({
  name: 'createReport',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(createReport.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(createReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        console.log('succeeded');
        window.alert(`${action.payload.message}`);
      })
      .addCase(createReport.rejected, (state, action) => {
        state.status = 'failed';
        window.alert('Something went wrong');
      })
      .addCase(createWaterReport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createWaterReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        window.alert(`${action.payload.message}`);
      })
      .addCase(createWaterReport.rejected, (state) => {
        state.status = 'failed';
        window.alert('Something went wrong');
      });
  },
});

export default createReportSlice.reducer;
